export const GET_CURRENT_USER_PROFILE_REQUEST = 'GET_CURRENT_USER_PROFILE_REQUEST';
export const GET_CURRENT_USER_PROFILE_SUCCESS = 'GET_CURRENT_USER_PROFILE_SUCCESS';
export const GET_CURRENT_USER_PROFILE_FAILURE = 'GET_CURRENT_USER_PROFILE_FAILURE';
export const UPDATE_CURRENT_USER_PROFILE_REQUEST = 'UPDATE_CURRENT_USER_PROFILE_REQUEST';
export const UPDATE_CURRENT_USER_PROFILE_SUCCESS = 'UPDATE_CURRENT_USER_PROFILE_SUCCESS';
export const UPDATE_CURRENT_USER_PROFILE_FAILURE = 'UPDATE_CURRENT_USER_PROFILE_FAILURE';


// WEBPACK FOOTER //
// ./src/features/Dashboard/types.js